import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";

import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";

import { useNavigate } from "react-router-dom";
import { getUser } from "../config/user";
import { RpaServices } from "../services/RpaServices";
import HospitalList from "../assets/hospitalList.svg";

import { fetchActiveCasesCount } from "../redux/caseDetailsSlice";
import { fetchManageQueriesCount } from "../redux/caseDetailsSlice";
import { fetchNewCaseNotificationCount } from "../redux/notificationSlice";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { AuthServices } from "../services/AuthServices";

const STAGING_API_BASE = "https://apistaging.settlemed.in";
const PRODUCTION_API_BASE = "https://apidigital.settlemed.in";

function normalizeApiBaseUrl(url) {
  return String(url ?? "")
    .trim()
    .toLowerCase()
    .replace(/\/+$/, "");
}

/**
 * Procedure Flow sidebar: only when hitting staging API; hidden on production.
 * Optional override: REACT_APP_SHOW_PROCEDURE_FLOW_SIDEBAR=true|false
 */
function shouldInjectProcedureFlowSidebar() {
  const flag = process.env.REACT_APP_SHOW_PROCEDURE_FLOW_SIDEBAR;
  if (flag === "true") return true;
  if (flag === "false") return false;
  const api = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);
  if (api === normalizeApiBaseUrl(STAGING_API_BASE)) return true;
  if (api === normalizeApiBaseUrl(PRODUCTION_API_BASE)) return false;
  return false;
}

const Sidebarorg = () => {
  const [navigationData, setNavigationData] = useState(null);

  // const [holdHospitalInfo, setHoldHospitalInfo] = useState(null);
  const [holdApplicationInfo, setHoldApplicationInfo] = useState(null);
  const dispatch = useDispatch();
  const { rpaPendingRequests } = useSelector(
    (store) => store.notificationReducer,
  );
  const {
    userAssignedStages,
    activeCasesCount,
    assignedCasesCount,
    manageQueriesCount,
  } = useSelector((store) => store.caseDetails);

  let user = getUser();

  // Check if a key is numeric
  const isNumericKey = (key) => !isNaN(key);

  // Recursively render menu
  const renderMenu = (node, level = 0) => {
    return Object.entries(node).map(([key, value]) => {
      if (!isNumericKey(key)) return null;

      const hasChildren = Object.keys(value).some((childKey) =>
        isNumericKey(childKey),
      );

      return (
        <div key={key}>
          {hasChildren ? (
            user?.roles?.filter(
              (role) => role.roleId === 14 || role.roleId === 13,
            )?.length > 0 &&
            value.navigation?.navigationName
              ?.toLowerCase()
              ?.includes("manage cases") ? (
              <></>
            ) : (
              <SubMenu
                label={
                  value.navigation?.aliasName ||
                  value.navigation?.navigationName
                }
                icon={
                  value?.navigation?.icon ? (
                    <img
                      src={value?.navigation?.icon}
                      height={20}
                      width={20}
                      alt="hospital-list-icon"
                    />
                  ) : (
                    <ManageAccountsOutlinedIcon style={{ color: "#017C57" }} />
                  )
                }
                title={
                  value.navigation?.navigationName ||
                  value.navigation?.aliasName
                }
              >
                {renderMenu(value, level + 1)}
              </SubMenu>
            )
          ) : (
            <MenuItem
              onClick={() => Navigate(value.navigation?.navigationUrl)}
              icon={
                value?.navigation?.icon ? (
                  <img
                    src={value?.navigation?.icon}
                    height={20}
                    width={20}
                    alt="hospital-list-icon"
                  />
                ) : (
                  <img
                    src={HospitalList}
                    height={20}
                    width={20}
                    alt="hospital-list-icon"
                  />
                )
              }
              title={
                value.navigation?.navigationName || value.navigation?.aliasName
              }
            >
              {value.navigation?.navigationName ||
                value.navigation?.aliasName ||
                "Untitled Menu"}{" "}
              {value.navigation?.aliasName
                ?.toLowerCase()
                ?.includes("active cases") ||
              value.navigation?.navigationName
                ?.toLowerCase()
                ?.includes("active cases") ? (
                <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                  ({activeCasesCount})
                </span>
              ) : value.navigation?.aliasName
                  ?.toLowerCase()
                  ?.includes("my cases") ||
                value.navigation?.navigationName
                  ?.toLowerCase()
                  ?.includes("my cases") ? (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#DC2626",
                  }}
                >
                  ({assignedCasesCount})
                </span>
              ) : value.navigation?.aliasName
                  ?.toLowerCase()
                  ?.includes("manage queries") ||
                value.navigation?.navigationName
                  ?.toLowerCase()
                  ?.includes("manage queries") ? (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#DC2626",
                  }}
                >
                  ({manageQueriesCount})
                </span>
              ) : value.navigation?.aliasName
                  ?.toLowerCase()
                  ?.includes("rpa request") ||
                value.navigation?.navigationName
                  ?.toLowerCase()
                  ?.includes("rpa request") ? (
                <div
                  style={{
                    fontSize: "10px",
                  }}
                >
                  {rpaPendingRequests}
                </div>
              ) : value.navigation?.aliasName
                  ?.toLowerCase()
                  ?.includes("rpa hospital") ||
                value.navigation?.navigationName
                  ?.toLowerCase()
                  ?.includes("rpa hospital") ? (
                <div className="text-[10px]">
                  {holdApplicationInfo &&
                    holdApplicationInfo.pmjayActiveHostipals}
                  / {holdApplicationInfo && holdApplicationInfo.totalHospitals}
                </div>
              ) : value.navigation?.aliasName
                  ?.toLowerCase()
                  ?.includes("rpa application") ||
                value.navigation?.navigationName
                  ?.toLowerCase()
                  ?.includes("rpa application") ? (
                <div className="text-[10px]">
                  {holdApplicationInfo &&
                    Number(holdApplicationInfo.totalHospitals)}
                  /{" "}
                  {holdApplicationInfo &&
                    holdApplicationInfo.pmjayActiveHostipals}
                </div>
              ) : (
                ""
              )}
            </MenuItem>
          )}
        </div>
      );
    });
  };

  const getUserNavigations = async () => {
    try {
      const res = await AuthServices.userSidebarNavigations();
      // setNavigationData(res?.data?.sideBar);
      const sidebar = res?.data?.sideBar || {};

      if (shouldInjectProcedureFlowSidebar()) {
        sidebar["999"] = {
          navigation: {
            navigationName: "Procedure Flow",
            aliasName: "Procedure Flow",
          },

          0: {
            navigation: {
              navigationName: "Manage Procedure",
              navigationUrl: "/dashboard/manage-procedure-page",
            },
          },

          1: {
            navigation: {
              navigationName: "Procedure Cost Mapping",
              navigationUrl: "/dashboard/procedure-cost-mapping",
            },
          },

          2: {
            navigation: {
              navigationName: "Default Document Mapping",
              navigationUrl: "/dashboard/default-doc-mapping",
            },
          },

          3: {
            navigation: {
              navigationName: "Procedure Master",
              aliasName: "Procedure Master",
            },
            0: {
              navigation: {
                navigationName: "Manage Documents",
                navigationUrl: "/dashboard/manage-documents",
              },
            },
            1: {
              navigation: {
                navigationName: "Manage Scheme",
                navigationUrl: "/dashboard/manage-scheme",
              },
            },
            2: {
              navigation: {
                navigationName: "Manage Speciality",
                navigationUrl: "/dashboard/manage-speciality",
              },
            },
            3: {
              navigation: {
                navigationName: "Manage Docx Type Mapping",
                navigationUrl: "/dashboard/managedocx-typemapping",
              },
            },
            4: {
              navigation: {
                navigationName: "Manage Procedure Scheme Mapping",
                navigationUrl: "/dashboard/manage-procedure-scheme-mapping",
              },
            },
            5: {
              navigation: {
                navigationName: "Master Procedure List",
                navigationUrl: "/dashboard/default-procedure-list",
              },
            },
          },
        };
      }

      setNavigationData(sidebar);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    dispatch(
      fetchManageQueriesCount({
        status: "ACTIVE",
        searchKey: "",
        hospitalId: "",
      }),
    );
  }, [dispatch]);
  useEffect(() => {
    const fetchApplicationData = async () => {
      if (user?.user) {
        const res = await RpaServices.getHoldApplication();
        setHoldApplicationInfo(res.data);
      }
    };

    fetchApplicationData();
    getUserNavigations();
  }, []);

  useEffect(() => {
    if (userAssignedStages) {
      dispatch(fetchActiveCasesCount(userAssignedStages));
    }
  }, [userAssignedStages]);
  const Navigate = useNavigate();

  return (
    <div
      style={{ fontFamily: "Inter" }}
      className="max-h-[100vh] bg-[#FBFBFB] overflow-y-scroll"
    >
      <Sidebar className="app">
        {navigationData && <Menu>{renderMenu(navigationData)}</Menu>}
      </Sidebar>
    </div>
  );
};
export default Sidebarorg;
